import { Pipe, PipeTransform } from '@angular/core';
import { Session } from 'src/app/models/session';
import { SpaceActionRulesService } from 'src/app/services/space-action-rules.service';

@Pipe({ name: 'cannotDeleteSpaceReason', standalone: true })
export class CannotDeleteSpaceReasonPipe implements PipeTransform {
  constructor(private spaceActionRules: SpaceActionRulesService) {}

  transform(space: Session): string | null {
    return this.spaceActionRules.getCurrentUserCannotDeleteSpaceReason(space);
  }
}
